// Nhịp "đang dùng ứng dụng" (identity Phụ lục A): POST /me/presence khi vào khung ứng dụng và mỗi 10 phút khi tab
// đang hiển thị — nguồn cột "Hoạt động gần nhất" ở Tài khoản. Server tự gộp (ghi tối đa 10 phút/lần); lỗi bỏ qua.
import { useEffect, useRef } from 'react';
import { http } from '@/shared/api';

export const PRESENCE_EVERY_MS = 10 * 60_000;
const CHECK_MS = 60_000;

const touch = () => http.post<{ recorded: boolean }>('/me/presence').catch(() => undefined);

export function usePresenceHeartbeat(enabled = true) {
  // Giữ qua lần gắn lại của StrictMode ⇒ không gửi trùng khi vừa vào
  const last = useRef(0);
  useEffect(() => {
    if (!enabled) return;
    const beat = () => {
      if (document.visibilityState !== 'visible' || Date.now() - last.current < PRESENCE_EVERY_MS) return;
      last.current = Date.now();
      void touch();
    };
    beat();
    const t = setInterval(beat, CHECK_MS);
    document.addEventListener('visibilitychange', beat);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', beat);
    };
  }, [enabled]);
}
